import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import notify from 'izitoast'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const login = () => import('@/views/login')
const error = () => import('@/views/error')
const dashboard = () => import('@/views/pilgrimage/statistics')
const pilgrimRegistration = () => import('@/views/pilgrimage/pilgrimRegistration')
const manage = () => import('@/views/pilgrimage/pilgrimsTable')
const installment = () => import('@/views/pilgrimage/installment')
const invoice = () => import('@/views/pilgrimage/invoice')
const invoiceMange = () => import('@/views/pilgrimage/manageInvoices')
const oldRegistration = () => import('@/views/pilgrimage/oldData')



Vue.use(Router)

function checkSession(to, from, next){
  // axios.get( "http://192.168.100.107:8080/pilgrimDB/login.php",
  axios.get( "pilgrimDB/login.php",
    { params:{session:'admin'}, withCredentials: true})
  .then(response=>{
    // console.log(response)
    if(response.data==1 ){
      next()
    }
    else{
      notify.error({title:"log in first", position:"topRight", timeout:"5000"})
      next('/login')
    }

  })
  .catch(error=>{
    if(!error.response){
      notify.error({title:"Network Error!", position:"topRight", timeout:7000})
    }

    console.log(error);
  })
}

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [ 
    {
      path: '/',
      redirect: '/login',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          beforeEnter: checkSession,
          component: dashboard,
          meta:{
            requiresAuth: true
          }
        },
        {
          path: 'pilgrimage',
          redirect: '/pilgrimage/registration/:pilgrim',
          name: 'Pilgrimage',
          beforeEnter: checkSession,
          props: true,
          component: {
            render : h => h('router-view') 
          },
          meta:{
            requiresAuth: true
          },
          children:[
            {
              path: 'registration/:pilgrim',
              name:'Registration',
              component: pilgrimRegistration,
              props: true
            },
            {
              path: 'manage',
              name:'Manage',
              component:manage
            },
            {
              path: 'payments/:pilgrim',
              name:'Payments',
              component: installment,
              props: true
            },
            {
              path: 'invoice/:pay',
              name:'Invoice',
              component: invoice,
              props: true
            },
            
            {
              path: 'oldRegistrations',
              name:'oldData',
              // redirect:'/pilgrimage/registration/:?mode:"oldData"',
              component: oldRegistration,
              // props:{mode:"oldData"}
            }
          ]
        },
        {
          path: 'invoice/manage',
          name:'manageInvoices',
          beforeEnter: checkSession,
          component: invoiceMange
        }
      ]
    },
    {
      path: '/login',
      redirect: '/login',
      name: 'Login',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/login',
          name: 'login',
          component: login,
          meta: { 
            requiresAuth: false
          }
        },
        {
          path: '/error',
          name: 'Error',
          component: error
        }
      ]
    }
  ]
})
